import useZone from 'hooks/useZone'
import ShopHoverSidebar from 'layout/ShopHoverSidebar'
import { ReactNode } from 'react'
import { Sidebar } from 'react-admin'
import { useLocation } from 'react-router-dom'
import { useFeatureFlag } from 'util/featureFlags'
import ControlSidebar from './ControlSidebar'

interface RouteAwareSidebarProps {
  children?: ReactNode
}

const RouteAwareSidebar = (props: RouteAwareSidebarProps) => {
  const { pathname } = useLocation()
  const isShop = pathname === '/shop' || pathname.startsWith('/shop/')
  const enabledShopUplift = useFeatureFlag('shop_uplift', 'on')
  const zone = useZone()

  if (zone === 'control') {
    return <ControlSidebar children={props.children} {...props} />
  }

  if (isShop && enabledShopUplift) {
    return <ShopHoverSidebar {...props} />
  }

  return <Sidebar {...props} />
}

export default RouteAwareSidebar
